function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5665 20.4286H16.5246C16.0986 20.4286 15.75 20.1071 15.75 19.7143C15.75 19.3214 16.0986 19 16.5246 19H33.5665C33.9925 19 34.3411 19.3214 34.3411 19.7143C34.3411 20.1071 33.9925 20.4286 33.5665 20.4286ZM33.5665 24.7143H16.5246C16.0986 24.7143 15.75 24.3929 15.75 24C15.75 23.6071 16.0986 23.2857 16.5246 23.2857H33.5665C33.9925 23.2857 34.3411 23.6071 34.3411 24C34.3411 24.3929 33.9925 24.7143 33.5665 24.7143ZM33.5665 29H16.5246C16.0986 29 15.75 28.6786 15.75 28.2857C15.75 27.8929 16.0986 27.5714 16.5246 27.5714H33.5665C33.9925 27.5714 34.3411 27.8929 34.3411 28.2857C34.3411 28.6786 33.9925 29 33.5665 29Z",
  fill: "black"
});

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6941 4.46046C15.5587 1.87825 20.1021 0.5 24.75 0.5C30.9826 0.5 36.9599 2.97589 41.367 7.38299C45.7741 11.7901 48.25 17.7674 48.25 24C48.25 28.6479 46.8717 33.1913 44.2895 37.0559C41.7073 40.9204 38.0371 43.9325 33.7431 45.7112C29.449 47.4898 24.7239 47.9552 20.1654 47.0484C15.6068 46.1417 11.4195 43.9035 8.133 40.617C4.84647 37.3305 2.60831 33.1432 1.70156 28.5846C0.794804 24.0261 1.26018 19.301 3.03884 15.0069C4.8175 10.7129 7.82955 7.04268 11.6941 4.46046Z",
    fill: "white",
    style: {
      stroke: "var(--color-primary)"
    },
    strokeMiterlimit: 10
  }), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.38320d31.svg";
export { ForwardRef as ReactComponent };